export default __webpack_public_path__ + "static/media/Icon_Community.b19c6be1.svg";